import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { fullName } from '../../../utils/textHelper';
import { logout } from '../../../store/actions/auth';

import styles from './UserActionsMenu.module.scss';

export function UserActionsMenu() {
  const ref = useRef();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.role);
  const [open, setOpen] = useState(false);

  useOnClickOutside(
    ref,
    useCallback(() => setOpen(false), []),
  );

  const handleClick = (e) => {
    if (ref.current === e.target) {
      setOpen(!open);
    }
  };

  return (
    <span onClick={handleClick} className={cn('ic-account', styles.userMenuWrapper)} ref={ref}>
      <div className={cn(styles.userMenu, open ? styles.shown : '')}>
        <div className={styles.inner}>
          {user ? (
            <section>
              <div className={styles.menuItem}>{fullName(user)}</div>
              <div className={styles.menuItem}>{user.email}</div>
            </section>
          ) : null}

          <hr />

          <section>
            <div>
              <NavLink
                to="/user/account"
                className={cn(styles.menuItem, styles.menuItemLink)}
                activeClassName={styles.active}
              >
                Settings
              </NavLink>
            </div>
          </section>

          <hr />

          <section>
            <div className={cn(styles.menuItem, styles.menuItemLink)} onClick={() => dispatch(logout())}>
              <span>Log out</span>
            </div>
          </section>
        </div>
      </div>
    </span>
  );
}
